import React from 'react';

type SectionHeaderProps = {
    icon: React.ReactNode;
    title: string;
    description?: string;
};

export const SectionHeader: React.FC<SectionHeaderProps> = ({
    icon,
    title,
    description,
}) => (
    <div className="flex items-start gap-3">
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-[var(--tc-primary-p-50)] shrink-0">
            {icon}
        </div>
        <div className="flex flex-col gap-1 min-w-0">
            <h3 className="font-bold text-high-em text-base m-0 leading-snug">
                {title}
            </h3>
            {description ? (
                <p className="text-body text-med-em m-0 leading-relaxed">
                    {description}
                </p>
            ) : null}
        </div>
    </div>
);
